import {AreaSegmentOptions} from "./constants"

export const getAreaSegment = (url: string): (typeof AreaSegmentOptions)[keyof typeof AreaSegmentOptions] | false => {
    if (url.includes("/shop")) {
        return AreaSegmentOptions.Shop
    }
    if (url.includes("/brands")) {
        return AreaSegmentOptions.Brands
    }
    if (url.includes("/promotions")) {
        return AreaSegmentOptions.Promotions
    }
    return false
}
